const SOCIAL_PROFILES = [
  'https://www.facebook.com/fixittask',
  'https://www.instagram.com/fixittask',
];

const DEFAULT_AREA = {
  '@type': 'AdministrativeArea',
  name: 'Ontario, Canada',
};

const createAreaServed = ({ city, region, cities } = {}) => {
  if (cities && cities.length > 0) {
    return cities.map(c => ({
      '@type': 'City',
      name: c,
      ...(region ? { containedInPlace: { '@type': 'AdministrativeArea', name: region } } : {}),
    }));
  }
  if (city) {
    return {
      '@type': 'City',
      name: city,
      ...(region ? { containedInPlace: { '@type': 'AdministrativeArea', name: region } } : {}),
    };
  }
  return DEFAULT_AREA;
};

/**
 * Build a LocalBusiness JSON-LD schema for handyman service pages.
 *
 * @param {Object} params
 * @param {string} params.rootUrl Marketplace root URL (e.g. https://fixittask.com)
 * @param {string} params.pageUrl Absolute URL of the page including this schema
 * @param {string} params.name Business / page name (e.g. "Handyman Services in Toronto")
 * @param {string} params.description Meta description for the page
 * @param {string} [params.image] Absolute image URL representing the page
 * @param {string} [params.city] City name (for areaServed)
 * @param {Array<string>} [params.cities] List of city names (for areaServed when serving multiple cities)
 * @param {string} [params.region] Region/state name (for areaServed)
 * @param {string} [params.serviceType] Optional schema.org subtype, e.g. "HomeAndConstructionBusiness"
 */
export const buildHandymanLocalBusinessSchema = ({
  rootUrl,
  pageUrl,
  name,
  description,
  image,
  city,
  cities,
  region = 'Ontario',
  serviceType = 'HomeAndConstructionBusiness',
}) => {
  const normalizedRootUrl = (rootUrl || '').replace(/\/$/, '');

  return {
    '@context': 'https://schema.org',
    '@type': ['LocalBusiness', serviceType],
    '@id': `${pageUrl}#localbusiness`,
    name,
    description,
    url: pageUrl,
    ...(image ? { image } : {}),
    priceRange: '$$',
    areaServed: createAreaServed({ city, region, cities }),
    parentOrganization: {
      '@type': 'Organization',
      '@id': `${normalizedRootUrl}#organization`,
      name: 'FixitTask',
      url: normalizedRootUrl,
      sameAs: SOCIAL_PROFILES,
    },
  };
};
